window.prepareNoticeToast = function(body_text) {
  $('.toast .toast-body').text(body_text);
  $('.feather-icon').data('feather', 'alert-circle')
  $('.toast .toast-header').addClass("bg-success");
  $('.toast .toast-header-title').text(banana.i18n('toast-info-title'));
}

window.prepareAlertToast = function(body_text) {
  $('.toast .toast-body').text(body_text);
  $('.feather-icon').data('feather', 'alert-triangle')
  $('.toast .toast-header').addClass("bg-warning");
  $('.toast .toast-header-title').text(banana.i18n('toast-warning-title'));
}

window.throw_flash = function() {
  try {
    var str = $('body').attr('data-flash'); // flh = {'notice': 'hello world'}
    var flh = JSON.parse(str)

    if (!$.isEmptyObject(flh)) {
      $('.toast .toast-header').removeClass("bg-success bg-warning");
      $('.toast').removeClass('d-none');

      if (flh.hasOwnProperty('notice')) {
        prepareNoticeToast(flh.notice);
      }
      if (flh.hasOwnProperty('alert')) {
        prepareAlertToast(flh.alert);
      }
      $('.toast').toast('show');
      setTimeout(function() { $('body').attr('data-flash', '{}'); }, 5000);
    }
  }
  catch(err) {
    // when you try to JSON.parse an empty string...
  }



  $('.toast').on('hidden.bs.toast', function () {
    $('.toast').addClass('d-none');
  })

  $('.toast').on('show.bs.toast', function () {
    $('.toast').removeClass('d-none');
  })
}


document.addEventListener("turbolinks:load", () => {  // iwan
  throw_flash();
});
